/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createReorderProductsResponseFromDiscriminatorValue, serializeReorderProductsRequest, serializeReorderProductsResponse, type ErrorResponse, type InternalErrorResponse, type ReorderProductsRequest, type ReorderProductsResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges the products inside one category. Position drives the order products are displayed in across the storefront, the Web Admin and the sales app. Send every product in that category exactly once, in the new order — adding, dropping, or repeating one is a 400. A product that belongs to several categories holds an independent position in each, so reordering one category leaves its position in the others untouched. A parent listing is ranked separately from its child, since browsing a parent lists everything beneath it.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderProductsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: ReorderProductsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderProductsResponse | undefined>;
    /**
     * Rearranges the products inside one category. Position drives the order products are displayed in across the storefront, the Web Admin and the sales app. Send every product in that category exactly once, in the new order — adding, dropping, or repeating one is a 400. A product that belongs to several categories holds an independent position in each, so reordering one category leaves its position in the others untouched. A parent listing is ranked separately from its child, since browsing a parent lists everything beneath it.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderProductsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/products/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderProductsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderProductsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
